module.exports = __webpack_public_path__ + "assets/total_leads_valid.3c0e992b.svg";